import { useEffect, useState } from 'react';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { useAdminSelector } from 'admin/reducers';
import { selectEditableCard, selectEditableStorySettings } from 'admin/reducers/card-editor/selectors';
import { selectEditableElement } from 'admin/reducers/card-editor-extra/selectors';
import {
	DEFAULT_DESIGN_MODE_GROUPS,
	mergeDesignModeSelection,
	resolveStoryDesignModeSelection,
} from 'common/design-tokens';

/** The editor viewer's system color scheme, which a Story set to Auto follows */
export function usePrefersDarkScheme() {
	const [prefersDark, setPrefersDark] = useState(
		() => window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
	);
	useEffect(() => {
		const query = window.matchMedia?.('(prefers-color-scheme: dark)');
		if (!query) return () => {};
		const update = () => setPrefersDark(query.matches);
		update();
		query.addEventListener('change', update);
		return () => query.removeEventListener('change', update);
	}, []);
	return prefersDark;
}

export function useInspectorDesignModeSelection() {
	const settings = useAdminSelector(selectEditableStorySettings);
	const card = useAdminSelector(selectEditableCard);
	const element = useAdminSelector(selectEditableElement);
	const prefersDark = usePrefersDarkScheme();

	const storySelection = resolveStoryDesignModeSelection(
		settings?.design?.modeGroups ?? DEFAULT_DESIGN_MODE_GROUPS,
		settings.designModes,
		{ prefersDark }
	);
	// A block's local selection affects only that block, never its parent's or children's appearance.
	return mergeDesignModeSelection(
		mergeDesignModeSelection(storySelection, card?.designMode),
		element?.uiConfig.componentProps[UNIFORM_PROPS.designMode]
	);
}
